import {
  HOME_FETCH_MODEL_DATA_BEGIN,
  HOME_FETCH_MODEL_DATA_SUCCESS,
  HOME_FETCH_MODEL_DATA_FAILURE,
  HOME_FETCH_MODEL_DATA_DISMISS_ERROR,
  HOME_SET_CURRENT_SEASON
} from './constants';

import axios from 'axios';
import moment from 'moment';
import {makeDictionary} from '../../common/util'
import { enqueueSnackbar, enqueueWarning, enqueueFailedRequestWarning} from './snackActions'
import { setCurrentSeason} from './setCurrentSeason';
import { fetchMissingProperties} from './fetchMissingProperties';
import { orderBy } from '../../common/orderby';




function makeFilterDictionary(arr, value=true)
{
  let result = {};
//  console.log({arr});
  if (!Array.isArray(arr))
    arr = Object.values(arr);
//  console.log({arr});
  arr.forEach(el => {if (el && el.name) result[el.name] = value;});
  return result;
}


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchModelData(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_FETCH_MODEL_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      
     
          let initialStateData = {};
      let dataRequests = [axios.get("/api/schedules/overview"),
                  axios.get("/api/plans"),
                  axios.get("/api/workers"),
                  axios.get("/api/seasons"),
                  axios.get("/api/roles"),
                  axios.get("/api/locations"),
                  axios.get("/api/properties"),
                  axios.get("/api/WorkerDateAvailability"),
                  axios.get("/api/WorkerLocationAvailability"),
                  axios.get("/api/WorkerLocationFrequency"),
                  axios.get("/api/WorkerRoleFrequency"),
                  axios.get("/api/WorkerRoleAvailability"),
                  axios.get("/api/WorkerAvailabilityFrequency"),
                  axios.get("/api/WorkerPairs"),
                  axios.get("/api/WorkerProperties")
                ];
      
      let numPending = dataRequests.length;
      
      let failed = false;
      dispatch(fetchMissingProperties());
      dataRequests.forEach(r => r.then(
        (res) => {
          numPending--;
          let data = res.data;
          
          Object.keys(data).forEach(k => 
            {
              console.log(k);
              if (Array.isArray(data[k]))
                initialStateData[k] = makeDictionary(data[k]);
              else
                initialStateData[k] = data[k];
            }
          );
          
          //console.log({initialStateData});
          if (numPending === 0)
          {
            dispatch({
              type: HOME_FETCH_MODEL_DATA_SUCCESS,
              data: initialStateData,
            });
            dispatch(setCurrentSeason(orderBy(Object.values(initialStateData.seasons), s => [s.from, s.to]).slice(-1)[0].id));
            resolve(initialStateData);
          }
          

        },
        
        (err) => {
            dispatch(enqueueFailedRequestWarning('Failed fetching data.',err));
          if (failed) return;
          failed = true;
          
          dispatch({
            type: HOME_FETCH_MODEL_DATA_FAILURE,
            data: { error: err },
          });
          
          reject(err);
        },
      ));
        

    return promise;
  });
}
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchModelDataError() {
  return {
    type: HOME_FETCH_MODEL_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_MODEL_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchModelDataPending: true,
        fetchModelDataError: null,
      };

    case HOME_FETCH_MODEL_DATA_SUCCESS:
      // The request is success
      let newState = {
        ...state,
        fetchModelDataPending: false,
        fetchModelDataError: null,
      };
      Object.keys(action.data).forEach(k => 
        newState[k] = action.data[k]);

      newState = {...newState, 
      filterables: {...newState.filterables,
        roles: makeFilterDictionary(newState.allRoles),
        locations: makeFilterDictionary(newState.allLocations),
        properties: makeFilterDictionary(newState.allProperties),
        unavailable: makeFilterDictionary(Object.values(newState.workers).filter(w => w.status).map(w => ({name: w.status})), false)
        }
      };
      return newState;

    case HOME_FETCH_MODEL_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchModelDataPending: false,
        fetchModelDataError: action.data.error,
      };

    case HOME_FETCH_MODEL_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchModelDataError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/fetchModelData.js